import React from "react"
import { BblTwoColumnWrapperBlockPreview } from "./queries"
import { makeStyles } from "@material-ui/styles"
import { buildBlocks } from "../../../services/builder"
import styles from "./styles"
import Wrapper from "../../Reusable/Wrapper"

const useStyles = makeStyles(theme => styles(theme))

export const BblTwoColumnWrapperBlock = ({
  attributes,
  innerBlocks,
  parentAttributes,
  pageContext,
}) => {
  const blocks = buildBlocks(innerBlocks, parentAttributes, pageContext)
  const classes = useStyles()

  const { className } = attributes

  return (
    <div
      className={`two-column-wrapper ${className} ${classes.twoColumnWrapper} `}
    >
      <Wrapper>
        {blocks.map(block => {
          return block
        })}
      </Wrapper>
    </div>
  )
}

export { BblTwoColumnWrapperBlockPreview }
